module.exports = __webpack_public_path__ + "assets/7d03f292095d890f8cccba3040fc45d7.mp3";